import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ErrorPage from './components/errorPage';
import { Navigate } from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import Branches from './components/tables/Branches';
import Managers from './components/tables/Managers';
import StudentDetails from './components/tables/StudentDetails';
import ChangePasswordForm from './components/forms/ChangePasswordForm';
import Batches from './components/tables/Batches';
import Login from './components/login/Login';
import AuthContext from './AuthContext';
import ProtectedWrapper from './ProtectedWrapper';
import Layout from './components/layout'; // Make sure Layout is imported
import AddStudent from './components/forms/StudentDetailsForm'
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [user, setUser] = useState('');
  const[userType,setUserType]=useState('')
  const [token,setToken]=useState('')
  const[admin,setAdmin]=useState('')
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUsername(user.name);
      setIsLoggedIn(true);
      setUser(user.id);
      setUserType(user.user_type)
      setAdmin(user.admin_id)
      setToken(user.token)
    }
  }, []);

  const signin = (newUser, callback) => {
    if (newUser && newUser.name) {
      localStorage.setItem('user', JSON.stringify(newUser));
      setUsername(newUser.name);
      setIsLoggedIn(true);
      setUser(newUser.id);
      setUserType(newUser.user_type)
      setAdmin(newUser.admin_id)
      setToken(newUser.token)
      if (callback) callback();
    }
  };

  const signout = () => {
    localStorage.removeItem('User');
    setUsername('');
    setUser('')
    setIsLoggedIn(false);
  };
  const value = { username, user,userType,admin, isLoggedIn, token,signin, signout };

  return (
    <AuthContext.Provider value={value}>
      <BrowserRouter>
        <Routes>

          <Route path="/login" element={<Login />} />
          <Route 
            path="/" 
            element={
              <ProtectedWrapper>
                <Layout/>
              </ProtectedWrapper>
            } 
          >
             
                    <Route index element={<Dashboard />} />
                    <Route path="/branches" element={
                    <ProtectedWrapper allowedRoles={['sa']}> 
                    <Branches />
                    </ProtectedWrapper> 
                  } />
                    <Route path="/batches" element={
                      <ProtectedWrapper allowedRoles={['sa','ad']}>
                        <Batches />
                      </ProtectedWrapper>
                    } />
                    <Route path="/managers" element={<Managers />} />
                    <Route path="/student-details" element={<StudentDetails />} />
                    <Route path='/add-student' element={<AddStudent/>}/>
                    <Route path="/change-password" element={<ChangePasswordForm />} />
            </Route>
            <Route path="/error-page" element={<ErrorPage />} />
            <Route path="*" element={<Navigate to="/error-page" replace />} /> {/* Redirect all other routes to ErrorPage */}
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
};

export default App;
